import React from "react";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import Login from "../Components/Login/Login";

const AdminLoginPage = () => {
  return (
    <>
      <Header minimal />
      <Login adminOnly />
      <Footer />
    </>
  );
};

export default AdminLoginPage;
